module.exports = __webpack_public_path__ + "img/icon-pingzheng.ae9c3fbf.svg";